// extracted by mini-css-extract-plugin
module.exports = {"container":"RemoveExpirationActionButtons_container__1gylB","buttons":"RemoveExpirationActionButtons_buttons__3XOS0"};